import { typography } from './settings'

export const headings = {
  main: {
    fontSize: typography.sizes.huge,
    fontWeight: typography.weights.normal,
    lineHeight: typography.lineHeights.large,
    fontFamily: typography.fontFamilies.main,
  },
  normal: {
    fontSize: typography.sizes.large,
    lineHeight: typography.lineHeights.medium,
    fontWeight: typography.weights.normal,
    fontFamily: typography.fontFamilies.main,
  },
  small: {
    fontSize: typography.sizes.medium,
    lineHeight: typography.lineHeights.small,
    fontWeight: typography.weights.semibold,
    fontFamily: typography.fontFamilies.main,
  },
  xSmall: {
    fontSize: typography.sizes.medium,
    lineHeight: typography.lineHeights.small,
    fontWeight: typography.weights.normal,
    fontStyle: 'italic',
    fontFamily: typography.fontFamilies.main,
  },
  xxSmall: {
    fontSize: typography.sizes.small,
    lineHeight: typography.lineHeights.small,
    fontWeight: typography.weights.semibold,
    fontFamily: typography.fontFamilies.main,
  },
  xxxSmall: {
    fontSize: typography.sizes.small,
    lineHeight: typography.lineHeights.small,
    fontWeight: typography.weights.normal,
    fontStyle: 'italic',
    fontFamily: typography.fontFamilies.main,
  },
}

export const body = {
  fontSize: typography.sizes.medium,
  lineHeight: typography.lineHeights.medium,
  fontWeight: typography.weights.normal,
  fontFamily: typography.fontFamilies.main,
}

export const small = {
  fontSize: typography.sizes.small,
  lineHeight: typography.lineHeights.medium,
  fontWeight: typography.weights.normal,
  fontFamily: typography.fontFamilies.main,
}
